import React, { useEffect } from 'react';
import { ExploreAll } from '@yme/assets/icons';
import { ICON_SIZE } from '@yme/atoms/svg-icon';
import { PAGE_TYPE } from '@yme/common/constants';
import { useIsOnScreen } from '@yme/common/hooks';
import { EXTRA_MENU_TYPE } from '@yme/components/Header/constants';
import { IconStyled, LinkStyled, LinkWrapperStyled } from '@yme/components/Header/styled';
import { SubMenuStyled, SubMenuWrapperStyled } from './styled';
export function SubMenu({ children, isUnitSubmenu, menuType, title, link, isRightToLeft, closeMenuHandler, isExtraMenuActive, }) {
    const { ref, element, isOnScreen } = useIsOnScreen();
    const withButton = [EXTRA_MENU_TYPE, PAGE_TYPE].includes(menuType) || isUnitSubmenu;
    useEffect(() => {
        if (isOnScreen) {
            element?.scrollTo(0, 0);
        }
    }, [isOnScreen, element]);
    return (React.createElement(SubMenuWrapperStyled, { isRightToLeft: isRightToLeft },
        React.createElement(SubMenuStyled, { isRightToLeft: isRightToLeft, isUnitSubmenu: isUnitSubmenu, isExtraMenuShowed: isExtraMenuActive, ref: isUnitSubmenu ? ref : null, withButton: withButton }, isUnitSubmenu ? isOnScreen && children : children),
        withButton && (React.createElement(LinkWrapperStyled, { isInSubMenu: true, isRightToLeft: isRightToLeft },
            React.createElement(LinkStyled, { to: link, onClick: closeMenuHandler },
                React.createElement(IconStyled, { type: ExploreAll, size: ICON_SIZE.s }),
                title)))));
}
